import { JSX, MouseEvent } from 'react';

import { NavLink } from 'react-router-dom';
import { Stack } from 'react-bootstrap';

interface IMenuItemNavLinkWithIcon {
    to?: string;
    icon?: string | React.ReactNode;
    label: string;
    onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
    openInNewWindow?: boolean;
}

export function MenuItemNavLinkWithIcon(props: IMenuItemNavLinkWithIcon) {
    const { icon } = props;

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        if (props.onClick) {
            e.preventDefault();
            props.onClick(e);
        }
    };

    return (
        <NavLink
            className="dropdown-item uppercase"
            to={props.to ?? '#'}
            onClick={handleClick}
            target={props.openInNewWindow ? '_blank' : '_self'}
        >
            <Stack direction="horizontal" gap={2}>
                <div className="drop-down-icon-wrapper">
                    {typeof icon === 'string' ? (
                        <i className={icon} style={{ color: 'inherit' }} />
                    ) : (
                        icon
                    )}
                </div>
                <span>{props.label}</span>
            </Stack>
        </NavLink>
    );
}
